import React from "react";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Link from "@amzn/meridian/esm/components/link";
import Theme from "@amzn/meridian/esm/components/theme/theme";

import zoomSdk from "@zoom/appssdk";
import LogManager from "../utils/LogManager";

/**
 * Component that displays an indicator when AIMS status is set to "summary to organizer"
 * meaning only the organizer will receive the meeting summary.
 */
const OrganizerOnlyIndicator = () => {
  const handleLearnMoreClick = async () => {
    try {
      await zoomSdk.openUrl({
        url: "https://w.amazon.com/bin/view/UnifiedCommunications/MeetingSummaries/AiMS",
      });
    } catch (error) {
      console.error("Failed to open URL in Zoom:", error);
      LogManager.error("Failed to open URL in Zoom:", error);
    }
  };

  return (
  <Column spacing="none">
    <Row width="100%" spacing="none" spacingInset="none">
      <Column width="72px"/>
      <Column spacing="none" width="226px">
        <Row alignmentHorizontal="start">
          <Text fontFamily="amazonEmber" type="h50" color="secondary">
            Meeting information unavailable
          </Text>
        </Row>
        <Column height="16px"/>
        <Row alignmentHorizontal="start">
          <Text fontFamily="amazonEmber" type="b200" alignment="start" color="secondary">
            Only you will receive the meeting summary when it's ready.
          </Text>
        </Row>
        <Column height="16px"/>
        <Row alignmentHorizontal="start">
          <Link onClick={handleLearnMoreClick} type="secondary">
            <Theme tokens={{ textColorPrimary: "#006D5B" }}>
              <Text color="primary" type="b200" fontFamily="amazonEmber">
                <u>Learn more</u>
              </Text>
            </Theme>
          </Link>
        </Row>
      </Column>
    </Row>
  </Column>
  );
};

export default OrganizerOnlyIndicator;
